import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import axios from '../../../utils/axiosConfig';
import { Button } from 'react-bootstrap';

export const downloadMedia = (downloadEndpoint) => {
  axios
    .get(downloadEndpoint)
    .then(response => {
      const downloadUrl = response.data.download_url;
      const link = document.createElement('a');
      link.href = downloadUrl;
      const filename = downloadUrl.split("/").pop();
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
    })
    .catch(error => {
      console.log(error);
    });
};

const DownloadButton = ({
  downloadEndpoint,
  title,
  size,
  variant,
  children,
  className
}) => {

  const onDownload = useCallback(() => downloadMedia(downloadEndpoint), [downloadEndpoint]);

  return (
    <Button
      className={className}
      variant={variant}
      size={size}
      onClick={onDownload}
    >
      {title || children}
    </Button>
  );
};

DownloadButton.propTypes = {
  downloadEndpoint: PropTypes.string.isRequired,
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ]),
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.node,
    PropTypes.arrayOf(
      PropTypes.node,
    )
  ]),
  size: PropTypes.oneOf(['sm', 'lg', 'xl']),
  variant: PropTypes.oneOf(
    ['primary', 'secondary', 'tertiary', 'success', 'warning', 'danger', 'info', 'light', 'dark']
  ),
  className: PropTypes.string
};

DownloadButton.defaultProps = {
  size: 'sm',
  variant: 'primary',
};

export default DownloadButton;
